module.exports = __webpack_public_path__ + "img/sw-face-xl.75f2593a.webp";